<template lang="html">
    <div id="preloader">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="margin: auto; display: block; shape-rendering: auto"
            width="128px"
            height="128px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle cx="50" cy="23" r="13" :fill="color">
                <animate
                    attributeName="cy"
                    dur="1s"
                    repeatCount="indefinite"
                    calcMode="spline"
                    keySplines="0.45 0 0.9 0.55;0 0.45 0.55 0.9"
                    keyTimes="0;0.5;1"
                    values="23;77;23"
                ></animate>
            </circle>
        </svg>
        <p :style="{ color: textColor }">Loading Lesson Pro...</p>
    </div>
</template>

<script>
export default {
    name: "pre-loader",
    props: ["textColor", "color"],
};
</script>

<style lang="scss" scoped>
#preloader {
    p {
        text-align: center;
    }
}
</style>
